import React from "react";
import couponicon from "../../../Assets/couponicon.png"
import "./style.css";

export default function CouponsDashboard() {
    return (
        <div className="coupons_dashboard">
            <div className="coupon_dashboard_tiles">
                <div className="coupon_dashboard_tile">
                    <div className="cardTitle_cdt">
                        <h2>Total</h2>
                        <p>Coupons</p>
                    </div>
                    <img src={couponicon} alt="" srcset="" />
                </div>
                <div className="coupon_dashboard_tile">
                    <div className="cardTitle_cdt">
                        <h2>Used</h2>
                        <p>Coupons</p>
                    </div>
                     <img src={couponicon} alt="" srcset="" />
                </div>
                <div className="coupon_dashboard_tile">
                    <div className="cardTitle_cdt">
                        <h2>Pending</h2>
                        <p>Coupons</p>
                    </div>
                     <img src={couponicon} alt="" srcset="" />
                </div>  
                <div className="coupon_dashboard_tile">
                    <div className="cardTitle_cdt">
                        <h2>Total</h2>
                        <p>Coupons</p>
                    </div>
                     <img src={couponicon} alt="" srcset="" />
                </div>
            </div>
        </div>
    )
}